import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveUnavailabilityRequestFailure({ uuid }) {
      const req = getState().find(
        ({ unavailability }) => unavailability.uuid === uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isRemoveUnavailabilityRequestPending({ uuid }) {
      const req = getState().find(
        ({ unavailability }) => unavailability.uuid === uuid,
      );

      return req ? req.request.isPending : false;
    },
    isRemoveUnavailabilityRequestSuccess({ uuid }) {
      const req = getState().find(
        ({ unavailability }) => unavailability.uuid === uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
